import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In listening experiments, it is possible to perceptually evaluate the quality of the simulation and the auralization. This can be achieved by comparing the simulation-based auralizations with measurement-based auralizations.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [0.5, 5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Attributes",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_STATIC_URL}/0330/lesson_3_28_Attributes.html`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "This test helps to reveal which attributes mostly contribute to the perceived differences. Only if differences are detected, the participant is asked to rate different attributes such as tone color or envelopment.",
                  direction: "row",
                  color: "default",
                },
              },
              styles: {
                width: "600px",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
